import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import Cache from '@aws-amplify/cache';
import { toast } from 'react-toastify';

export class Profile extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    name: '',
    email: '',
    phone: '',
    address: '',
    photo: '',
    abn: '',
    errors: {}
  }

  componentWillMount() {
    this.fetchSupplierData();
  }

  handleChange (evt) {
    var errors = this.state.errors
    if (evt.target.name === 'name') {
      errors[evt.target.name] = !/^[A-Za-z\s]+$/.test(evt.target.value)
    } else if (evt.target.name === 'email') {
      errors[evt.target.name] = !/[^@]+@[^\.]+\..+/.test(evt.target.value)
    } else if (evt.target.name === 'address') {
      errors[evt.target.name] = !/^[A-Za-z0-9\s,]+$/.test(evt.target.value)
    } else if (evt.target.name === 'abn') {
      errors[evt.target.name] = !/^[0-9\s]+$/.test(evt.target.value)
    }
    this.setState({ [evt.target.name]: evt.target.value, errors: errors });
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          console.log(data);
          this.setState({
            name: data[0].name,
            email: data[0].email,
            phone: data[0].phone,
            address: data[0].address,
            photo: data[0].photo,
            abn: data[0].abn
          });
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSupplier = async () => {
    let requestParams = {
      'name': this.state.name,
      'email': this.state.email,
      'phone': this.state.phone,
      'address': this.state.address,
      'photo': this.state.photo,
      'abn': this.state.abn
    }
    axios.post('/user/update/profile', requestParams)
        .then(data => {
          console.log(data);
          toast.success("Profile Saved!");
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error("Error: Could not update profile");
        })
  }

  uploadImage = e => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      let requestParams = {
        'fileName': 'profile_' + this.props.user.supplierID + '_' + file.name,
        'fileType': file.type
      }
      axios.post('/user/update/image', requestParams)
          .then(data => {
            console.log(data);
            const options = {
              headers: {
                'Content-Type': file.type,
              }
            };
            axios.defaults.headers.common = {}
            axios.put(data.url, file, options)
              .then(data2 => {
                console.log(data2);
                this.setState({
                  photo: data.finalUrl
                });
              })
              .catch (err2 => {
                console.log(err2);
                Rollbar.error(err2)
                toast.error("Error: Could not upload image");
              })
              .then(() => {
                axios.defaults.headers.common = {'Authorization': 'Bearer ' + Cache.getItem('supplier_auth_token')}
              })
          })
          .catch (err => {
            console.log(err);
            Rollbar.error(err)
            toast.error("Error: Could not get s3 upload url");
          })
    }
  };

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Profile</h1>
              </div>
              <div className="card">
                <div className="card-header">
                  Supplier Profile
                </div>
                <div className="card-body">
                  <div className="form-group">
                  <label>Name:</label>
                  <input type="text" value={this.state.name} onChange={this.handleChange} name="name" className={this.state.errors.name ? "form-control is-invalid" : "form-control"} />
                </div>
                <div className="form-group">
                  <label>Phone Number:</label>
                  <input type="tel" value={this.state.phone} onChange={this.handleChange} name="phone" className={this.state.errors.phone ? "form-control is-invalid" : "form-control"} />
                </div>
                <div className="form-group">
                  <label>Email Address:</label>
                  <input type="email" value={this.state.email} onChange={this.handleChange} name="email" className={this.state.errors.email ? "form-control is-invalid" : "form-control"} />
                </div>
                <div className="form-group">
                  <label>Address:</label>
                  <input type="text" value={this.state.address} onChange={this.handleChange} name="address" className={this.state.errors.address ? "form-control is-invalid" : "form-control"} />
                </div>
                <div className="form-group">
                  <label>ABN:</label>
                  <input type="text" value={this.state.abn} onChange={this.handleChange} name="abn" className={this.state.errors.abn ? "form-control is-invalid" : "form-control"} />
                </div>
                <div className="form-group productImg">
                  <label>Logo:</label>
                  <div className="custom-file mb-2">
                    <input type="file" className="custom-file-input" id="customFile" accept='image/*' onChange={this.uploadImage}/>
                    <label className="custom-file-label" htmlFor="customFile">Choose file</label>
                  </div>
                  <div className="preview-img-border">
                    {this.state.photo ? <img src={this.state.photo} alt="profile logo" /> : <p>Please upload a company logo</p>}
                  </div>
                </div>
                <button type="button" onClick={this.updateSupplier.bind(this)} className="btn btn-success btn-block" disabled={this.state.errors.name || this.state.errors.email || this.state.errors.phone || this.state.errors.address || this.state.errors.abn}>Save</button>
                </div>
              </div>
            </div>
        );
    }
}
